import { Dropdown } from 'primereact/dropdown';
import { TextBodyLarge } from '../text/Texts';
import { cn } from '../ui/cn';
import { useState } from 'react';
import { MdArrowDropDown, MdArrowUpward, MdKeyboardArrowDown } from 'react-icons/md';

const SelectLanguageDropdown = () => {
	const options = ['English', 'Tagalog', 'Italian'];
	const [value, setValue] = useState('English');
	const [isShow, setIsShow] = useState(false);
	const [isFocus, setIsFocus] = useState(false);

	const dropdownIcon = (
		<MdKeyboardArrowDown
			size={18}
			className={cn(
				'text-primary transition-transform duration-300',
				isShow ? 'rotate-0' : '-rotate-180'
			)}
		/>
	);

	const itemTemplate = (option: any) => {
		const isSelected = value === option;

		return (
			<TextBodyLarge 
				className={cn(
					'px-3 py-[14px] text-onSurface',
					isSelected ? 'bg-neutralVariant95' : 'bg-surfaceContainer',
					'transition duration-300 hover:bg-neutralVariant95',
				)}
				text={option}
			/>
		);
	}

	return (
		<Dropdown
			options={options}
			placeholder={value}
			itemTemplate={itemTemplate}
			onChange={(e) => setValue(e.value)}
			dropdownIcon={dropdownIcon} collapseIcon={dropdownIcon}
			onShow={() => setIsShow(true)} onHide={() => setIsShow(false)}
			onFocus={() => setIsFocus(true)} onBlur={() => setIsFocus(false)}
			pt={{
				root: { className: cn(
					'flex flex-row items-center gap-2 h-10 pl-6 pr-4 rounded-[100px]',
					'transition duration-300 hover:bg-statelayers-primary-opacity0-12',
					'bg-none bg-transparent', { 'bg-statelayers-primary-opacity0-12': isShow }
				)},
				input: { className: 'font-poppins text-label-large2 text-primary align-middle p-0' },

				panel: { className: 'w-[158px] rounded-[4px] py-2 bg-surfaceContainer shadow-[0px_2px_6px_2px_#00000026,0px_1px_2px_0px_#0000004D]' },
				item: { className: 'p-0' },
				itemLabel: { className: 'w-full' },

				trigger: { className: 'h-[18px] w-[18px]' },
			}}
		/>
	);
};

export default SelectLanguageDropdown;
